const ru: any = {
  // loader
  "loading-main": "Просим вас подождать данные загружаются...",
  // auth Header
  "online reception": "Цифровые банковские услуги",
  Individual: "Физическое лицо",
  Entity: "Юридическое лицо",
  // auth footer
  phone: "телефон",
  Address: "Адрес",
  "All right reserved": "Все права защищены",
  slogan: "Создайте свое будущее вместе с нами!",
  address_of_the_bank: "Aşgabat ş.Magtymguly şaýoly 111/2",
  // Login page
  "Sign in": "Вход",
  "Sign up": "Зарегистрироваться",
  "Forgot password": "Забыли пароль",
  Enter: "Войти",
  Username: "Имя пользователя",
  Password: "Пароль",
  "Invalid grand": "Неправильное имя пользователя или пароль",

  // register page
  "success registered": "Вы успешно зарегистрировались",
  "user has already registered": "Пользователь с таким именем уже существует",
  "email has already registered":
    "Пользователь с такой электронной почтой уже существует",
  "Is not same passwords": "Пароли не совпадают",
  "Minimum 8 symbol": "Минимум 8 символов",
  Name: "Имя",
  Surname: "Фамилия",
  "Phone number": "Телефонный номер",
  Email: "Email",
  "Input email correctly": "Введите еmail корректно",
  "User data": "Данные пользователя",
  "Private data": "Личные данные",
  "Password confirm": "Введите пароль повторно",
  Required: "Это объязательное поле",
  Back: "Назад",
  "register disabled":
    "ЮРИДИЧЕСКИМ ЛИЦАМ НЕОБХОДИМО СВЯЗАТЬСЯ С БАНКОМ ДЛЯ ПОДКЛЮЧЕНИЯ ДАННОЙ УСЛУГИ",
  // request status
  "Successfully sent": "Успешно отправлено",
  "filled inputs": "Заполненные поля",
  // room header
  "Call-center": "Справочная",
  Profile: "Профиль",
  "Change password": "Изменить пароль",
  Logout: "Выйти",
  "Are you sure to exit": "Хотите выйти?",
  // room
  Welcome: "Добро пожаловать",
  // maintable
  Type: "Тип",
  Date: "Дата создания",
  inviteDate: "Дата приглашения",
  noInviteDate: "Не указано",
  Status: "Статус",
  Action: "Действие",
  "Per page": "На каждой странице",
  Rejected: "Отказано",
  Done: "Готов",
  Success: "Принято",
  Pending: "Ожидание",
  Corrected: "Исправлено",
  paymentPending: "Ожидание оплаты",
  correctionRequired: "Внесите правки",
  // ViewItem
  Info: "Информация",
  Notes: "Заметки",
  "type of document": "Тип документа",
  "type of card": "Тип карты",
  "type of credit": "Тип кредита",
  "By who": "Имя заявителя",
  "Is hurry": 'Услуга "Срочно"',
  "With delivery": 'Услуга "Доставка"',
  Yes: "Да",
  No: "Нет",
  "Max credit amount": "Максимальная сумма кредита",
  "Credit amount": "Сумма кредита",
  "Credit percentage": "Процентная ставка",
  "Credit term": "Срок кредита",
  "Credit repayment base": "Обеспечение возврата долга",
  "credit repayment sources": "Источники погашения долга",
  "credit repayment ways": "Способы погашения долга",
  "No note": "Заметок нет",
  invitationDate: "Дата и время приглашения",
  invitationNote: "Примечание к приглашению",
  correctionNote: "Примечание к исправлению",
  //steps
  "Select type of card": "Выберите тип карты",
  "Input private data": "Данные заказчика",
  "Card data": "Данные для получение карты",
  "Extra data": "Дополнительные данные",
  "Select payment type": "Выберите тип оплаты",
  // private date
  "Input name correctly": "Введите имя корректно",
  "Input surname correctly": "Введите фамилию корректно",
  "Input thirdname correctly": "Введите отчество корректно",
  "Input birthdate correctly": "Введите дату рождения корректно",
  //
  Thirdname: "Отчество",
  Birthdate: "Дата рождение",
  "Passport serie": "Паспортная серия",
  "Passport given date": "Дата выдачи паспорта",
  "Passport given place": "Место выдачи паспорта",
  Gender: "Пол",
  Male: "Мужской",
  Female: "Женский",
  male: "Мужской",
  female: "Женский",
  Turkmen: "Туркмен",
  turkmen: "Туркмен",
  Other: "Другое",
  Nationality: "Национальность",
  "0": "Нет",
  "1": "Да",
  false: "Нет",
  true: "Да",
  /////////////////////////////çard info
  "Name latin": "Имя (латинскими буквами)",
  "Surname latin": "Фамилия (латинскими буквами)",
  "Input latin": "Только латинскими буквами",
  "sms connection": "Услуга - СМС подключение",
  "Home phone": "Домашний телефон",
  "Birth place": "Место рождения",
  "Code word to define":
    "Кодовое слово для вашей идентификации при обращении в банк",
  "Secret word": "Кодовое слово",
  Note: "Заметка",
  "Select branch": "Выберите головной банк или отделение банка",
  Services: "Дополнительные услуги",
  ourServices: "Услуги",
  deliveryService: "Услуга доставки",
  hurryService: "Услуга 'Срочно'",
  Next: "Вперед",
  close: "Закрыть",
  "Card payment": "Оплата карты",
  "Summary payment": "Сумма оплаты",
  "Confirm the data": "Подтвердите данные",
  Branch: "Головной банк или отделение банка",
  "I confirm": "Подтверждаю",
  Correct: "Исправить",
  ////////////new Credit request
  "Credit data": "Данные для кредита",
  "Credit calculator": "Кредитный калькулятор",
  "Select type of credit": "Выберите тип кредита",
  "year-a": "года",
  year: "год",
  years: "лет",
  monthes: "месяцев",
  thousand: "тыс.",
  month: "месяц",
  "month-a": "месяца",
  "monthly payment": "Ежемесячный платёж",
  "Percentage payment": "Процентный платеж",
  "Credit payment": "Платеж для погашения основной суммы",
  "Need salary for credit": "Необходимый доход для кредита",
  "Credit requirement": "Обеспечение возврата долга",
  "credit calc notice 1":
    "Размер ежемесячного платежа определяется сроком кредита",
  "credit calc notice 2":
    "Расчёт был сделан с таким учетом: 365 дней в 1 году и 30 дней в 1 месяце в среднем",
  "Salary or family income": "Сумма месячной зарплаты или дохода семьи",
  "Can input salary or family income":
    "Может быть введен сумма месячной зарплаты или дохода семьи",
  "Work position": "Должность",
  "Work experience": "Стаж с последней месты работы",
  "Work place": "Место работы",
  ///////////////request result/////////////
  "Success requested": "Ваша заявка успешно принята",
  "Some error, try it again": "Ошибка, повторите попытку",
  "Notice you about website":
    "Сообщаем Вам, что перечень документов размещен на официальном сайте Акционерно-Коммерческого Банка «Рысгал». Чтобы перейти на страницу",
  "follow the link": "перейдите по этой ссылке",
  "Responsible staff": "Ответственный за вас сотрудник",
  "Necessary docs": "Необходимые документы",
  successDialogNotice:
    "Ваша заявка будет рассмотрена специалистами банка, и Вам будет отправлено SMS-уведомление о статусе заявки.",
  "Bank address": "Адрес банка",
  "Room location": "Местонахождение кабинета",
  Floor: "Этаж",
  Room: "Кабинет",
  /////////////////new document request
  "Online service payment": "Онлайн услуга",
  "Is bussinessman": "Предприниматель",
  "Select type of document": "Выберите тип документов",
  "Document data": "Данные для документа",

  //////////////////EmptyData.js
  "Yuzlenme yok": "Нет заявок",
  ////////////////////HomePhone.js
  "Input home phone correctly": "Введите домашний телефон правильно",
  ///////////////////////Nationality.js
  "Input nationality correctly": "Введите национальность правильно",
  ///////////////////////////PassportGiýenDate.js
  "Проверьте правильность даты выдачи": "Проверьте правильность даты выдачи",
  "Дата выдачи не может быть в будущем": "Дата выдачи не может быть в будущем",
  ///////////////////////PassportGivenPlace
  "Input passport given place correctly": "Введите правильное место в паспорте",
  ////////////////////////////Passport number
  "Input passport serie correctly": "Введите серию паспорта правильно",
  //////////////////////////////EmailÝerify.js
  "Açary çalyşmak üçin ssylka email-e ugradyldy":
    "Ссылка отправлена ​​на почту для смены пароля",
  "Email-i dogry giriziň": "Введите адрес электронной почты правильно",
  "Açary dikeltmek": "Сброс пароля",
  "Email dogry girizin": "Введите адрес электронной почты правильно",
  Ýapmak: "Закрыть",
  Ugratmak: "Отправить",
  ///////////////////////Foooter.js
  "Geljegiňizi biz bilen dörediň!": "Создавай будущее вместе с нами!",
  ///////////////////CardInfoCheck.js
  Informations: "Информация",
  "Töleg maglumatlary": "Информация об оплате",
  "Agree to payment policy": "Согласен с политикой оплаты",
  ///////////////////////CardSelect.js
  "Hasaplaşyk walýutasy": "Расчетная валюта",
  ////////////////CreditCalc.js
  "Karzyň möhletine görä her aýdaky tölegiň möçberi kesgitlenýär":
    "Размер ежемесячного платежа определяется сроком кредита",
  "1 ýylda 365 gün we ortaça 1 aýda 30 gün hasaby bilen":
    "Рассчитан с таким учетом: 365 дней в году и 30 дней в месяце",
  /////////////////////CreditInfoCheck.js
  "Karz maglumatlary": "Информация о кредите",
  "Agree to private policy": "Согласен с политикой конфиденциальности",
  //////////////////////CreditInfoSection.js
  "Not enough salary or family income": "Не хватает зарплаты или дохода семьи",
  "Not enough experience": "Недостаточно опыта",
  ///////////////////////////////////Header
  "Home page": "Главная",

  //////////////////////////////Sidebar
  "Card section": "Получить карту",
  "Document section": "Получить справку",
  "Feedback section": "Жалобы и предложения",
  profile: "Профиль",
  "Credit section": "Получить кредит",
  /////////////////////////Restore.jsx
  "Açar üstünlikli dikeldildi": "Ключ успешно восстановлен",
  "Näsazlyk, dikeltme wagty tamamlandy":
    "Проблема, время восстановления истекло",
  "Email-i dogry girizin": "Введите адрес электронной почты правильно",
  "Näsazlyk, täzeden barlap görüň": "Ошибка, попробуйте повторно",
  "Gizlin açar söz gaýtalap": "Повторно введите пароль",
  "Açarlar deň gelenok": "Ключи не совпадают",
  Dikeltmek: "Восстановить",
  ///////////////////////////////////pages/Room/Card
  "Kart almak üçin onlaýn ýüzlenme": "Онлайн заявка для получения карты",
  "Ýüzlenme ugratmak": "Отправить заявку",
  ////////////////////////pages/Room/Credit
  "Karz almak üçin onlaýn ýüzlenme": "Онлайн заявка для получения кредита",
  //////////////////////////////////////////pages/Room/Document.jsx
  "Güwanama üçin onlaýn ýüzlenme": "Онлайн заявка на документ",
  /////////////////////////////pages/Room/Profile/Offers
  "Offered cards": "Заявки на карту",
  "Offered credits": "Заявки на кредит",
  "Offered documents": "Заявки на документ",

  //////////////////////////////pages/Room/passwordChange
  "old password": "Старый пароль",
  "new password": "Новый пароль",
  "new password confirm": "Новый пароль повторно",
  Change: "Изменить",

  "easy code": "Лёгкий пароль",
  "middle code": "Средний пароль",
  "hard code": "Сложный пароль",
  "input data is incorrect": "Введены неправильные данные",
  "password successfully changed": "Пароль успешно изменена",
  "some advices for password": "Некоторые советы",
  "at least one uppercase":
    "Пароль должен содержать как минимум 1 букву в верхнем регистре (A-Z)",
  "at least one number": "Пароль должен содержать как минимум 1 цифру (0-9)",
  "at least eight charecter": "Пароль должен содержать как минимум 8 символов",

  ////////////////////////////pages/Room/feedback
  "Feedback type": "Выберите тип заявки",
  complain: "Жалоба",
  recommend: "Предложение",
  "Your text": "Ваш текст",
  ////////////////////////////pages/Room/feedback
  "Select department": "Выберите отдел",
  "Meeting purpose": "Тема встречи",
  "Select your free date": "Выберите дату посещение банка",
  "Meet time": "Выбранная дата",
  /////////////////////////////////////////
  "New request": "Новая заявка",
  "Profile Edit": "Изменить",
  MiddleName: "Отчество",
  ChooseRegion: "Выберите отделение вашего банка",
  "Edit Profile": "Изменить профиль",

  "Add MoreInfo": "Добавить дополнительную информацию",
  "Save MoreInfo": "Сохранить дополнительную информацию",
  "Save Changes": "Сохранить изменения",
  "Message from organization": "Письменное обращение от организации",
  mary: "Мары",
  balkan: "Балкан",
  dasoguz: "Дашогуз",
  ashgabat: "Ашгабат",
  lebap: "Лебап",
  "Online Payment": "Онлайн оплата",
  "Total Amount": "Итоговая сумма",
  Passport: "Пасспорт",
  "Birth date": "День рождения",
  PrivateAutoFill:
    "Ваши данные заполнены автоматически но вы можете их изменить",
  ImageChangeHelpText:
    "Нажмите на  '+' чтобы прикрепить скан вашего письма с обращением к банку",
  ScanAreaMove: "Переместите скан сюда",
  supportScanType: "Поддерживаемый формат",
  writeYourMessage: "Введите своё сообщение",
  originNumber: "Исходящий номер",
  scanDate: "Выберите дату заявки",
  notEntered: "Не задано",
  dataSuccesChanged: "Данные успешно изменены",
  dataSuccesSaved: "Данные вашего профиля успешно сохранены",
  Error: "Ошибка",
  PleaseFillYourProfileData:
    "Пожалуйста заполните дополнительные данные вашего профиля",
  Fill: "Заполнить",
  noNotifications: "У вас пока нет никаких уведомлений",
  uploadMaxSizeError:
    "Ошибка. Размер файла привысил лимит в 2 мегабайт. Пожалуйста выберите файл который весит меньше 2 мегабайт",
  fileErrorTryAgain: "Ошибка. При попытке удалить файл",
  attention: "Внимание",
  descriptionFillProfile:
    "Настоятельно рекомендуем вам заполнить ваши данные профиля для автоматического заполнения при разных действиях к личном кабинете вы можете проигнорировать это сообщение и нажать 'Продолжить' тогда вы сможете самостоятельно вручную заполнить данные без автозаполнения полей.",
  fillOutData: "Заполнить данные",
  continue: "Продолжить",
  loading: "Загрузка",
  faceType5: "Физическое лицо",
  faceType1: "Юридическое лицо",
  check: "Проверить",
  sentAgain: "Отправить ещё",
  WeSentOnYourEmailMessage: "Мы отправили на вашу почту",
  MessageForEdentify: "сообщение, подтвердите вашу личность чтобы продолжить",
  YourEmailIsNotFerfied: "Ваша почта не подтверждена!",
  anotherEmailMessageSented: "Повторное сообщение на почту отправлено",
  emailSentVerifyError: "Произошла ошибка при отправке повтороного сообщения",
  noVerifiedEmail: "Требуется подтверждение почты",
  verifiedEmail: "Почта подтверждена",
  GivenDateCantBeAFuture: "Дата выдачи не может быть в будущем",
  Add: "Добавить",
  youEmailSuccesVerified: "Ваша почта успешно подтверждена",
  errorVerifyEmail:
    "Ошибка подтверждения почты. Пожалуйста проверьте вашу почту",
  succesVerifyEmail: "Поздравляем вы успешно подтвердили почту",
  ForeignStudent: "Об оплате за обучение",
  PaymentForeignStudent: "Заявка на международный платёж",
  PaymentForeignStudentTitle: "Онлайн заявка на международный платёж",
  selectPaymentType: "Выберите тип оплаты",
  comingSoon: "В разработке",
  "otp-send-to-your-phone": "OTP отправлен на ваш телефон",
  "login-success": "Вход выполнен успешно",
  receiverInfo: "Информация о получателе",
  senderInfo: "Информация об отправителе",
  Patronymic: "Отчество",
  "Surname Before Changed": "Фамилия до изменения",
  "Passport Serial": "Серия паспорта",
  "Passport Number": "Номер паспорта",
  "Passport Given Date": "Дата выдачи паспорта",
  "Passport Given Place": "Место выдачи паспорта",
  Phone: "Телефон",
  "Birth Place": "Место рождения",
  "Village / City / etc.": "Село / Город / и т.д.",
  "House / Flat Number": "Дом / Квартира",
  "Select receiver": "Выберите получателя",
  currency: "Валюта",
  "Uploading...": "Загрузка...",
  Receiver: "Получатель",
  "Change info": "Изменить данные",
  "No receivers available": "Нет доступных получателей",
  "Add new receiver": "Добавить нового получателя",
  "Create new receiver": "Создать нового получателя",
  "Edit receiver": "Редактировать получателя",
  "Receiver successfully created": "Получатель успешно создан",
  "Failed to create receiver": "Не удалось создать получателя",
  "Receiver successfully updated": "Получатель успешно обновлен",
  "Failed to update receiver": "Не удалось обновить получателя",
  "Only letters allowed": "Разрешены только буквы",
  "Minimum 3 characters": "Минимум 3 символа",
  "Maximum 50 characters": "Максимум 50 символов",
  livingAddress: "Адрес проживания",
  formalAddress: "Адрес прописки",
  workUniver: "Полное название университета",
  Country: "Страна",
  "Select country": "Страна, где находится получатель",
  "Birth Date": "Дата рождения",
  "Format: I-AB or II-CD": "Формат: I-AŞ или II-DZ",
  "Must be exactly 6 digits": "Должно быть ровно 6 цифр",
  "Phone format must start with + and contain only digits":
    "Phone format must start with + and contain only digits",
  "Only letters, numbers, commas, slashes, and hyphens allowed":
    "Допускаются только буквы, цифры, запятые, слэши и дефисы",
  // Gender: "Пол",
  // Male: "Мужской",
  // Female: "Женский",
  // Nationality: "Национальность",
  Citizenship: "Гражданство",
  "Select citizenship": "Выберите гражданство",
  Cancel: "Отмена",
  "Save Receiver": "Сохранить получателя",
  // "Save Changes": "Сохранить изменения",
  or: "или",
  onlyTurkmenistanCitizens:
    "На текущем этапе получателем может быть только гражданин Туркменистана",
  "type of payment": "Тип платежа",
  Amount: "Сумма",
  "Visa status": "Статус визы",
  "Select visa status": "Выберите статус визы",
  VisaStudent: "Студент",
  VisaTourist: "Турист",
  VisaWork: "Рабочая",
  Documents: "Документы",
  "Payer documents": "Документы отправителя",
  "Payee documents": "Документы получателя",
  senderDocs:
    "Документы отправителя (паспорта (местный, заграничный), трудовая книжка, пенсионное удостоверение, справка с работы)",
  receiverDocs:
    "Документы получателя (справка с учёбы (если студент), банковские реквизиты, паспорта (местный, заграничный), документы, подтверждающие родственные связи, вид на жительство)",
  "File size must be under 2MB": "Размер файла должен быть меньше 2 МБ",
  "Enter valid amount": "Введите правильную сумму",
  "Sender Information": "Информация об отправителе",
  "Receiver Information": "Информация о получателе",
  "Payment Information": "Информация о платеже",
  "Surname before changed": "Прежняя фамилия",
  "City / village": "Город / село",
  "House / flat number": "Дом / квартира",
  "Private Information": "Личная информация",
  "Passport Information": "Паспортные данные",
  "Work Information": "Информация о работе",
  Workplace: "Место работы",
  Salary: "Зарплата",
  "Job title": "Должность",
  "Please wait...": "Пожалуйста, подождите",
  "Verify Code": "Подтвердите код",

  alerts: {
    interPayment: {
      blockedByBank:
        "Чтобы воспользоваться услугой оплаты обучения, обратитесь к соответствующему банковскому оператору для проверки ваших документов. После прохождения проверки вы сможете отправить онлайн-заявку.",
      docInactive:
        "Поскольку ваши документы устарели, просим вас повторно пройти проверку.",
      docExpiredOn: "Срок действия документа истёк {{date}}",
      docExpirationNotSet:
        "Срок действия документа не установлен администратором.",
    },
  },
  man: "Мужчина",
  woman: "Женщина",
  reqDosc: "Документы (оригиналы обязательны)",
  reqDocsDesc: "Описание",
  reqDocsUpload: "Загрузка документов",
  "Choose Files": "Выбрать файлы",
  addMoreFiles: "Добавить файлы",
  "Replace files": "Заменить файлы",
  uploadedFiles: "Загруженные файлы",
  "Already uploaded files": "Загруженные файлы",
  "Selected files": "Выбранные файлы",
  "No fields required for this payment type":
    "Нет полей, необходимых для этого типа оплаты",
  newInterPaymentTitle: "Уважаемые клиенты!",
  newInterPaymentAlert:
    "Доводим до вашего сведения, что если оплата за обучение и проживание производится через наш банк, ежемесячные денежные переводы студентам осуществляются исключительно на основании электронной заявки.",
  newInterPaymentAlertCheck: "Ознакомлен(а)",
  requestInfoDialog: {
    linkText: "условия соглашения",
    text: {
      beforeLink: "Я подтверждаю",
      afterLinkBeforeAction:
        "настоящей онлайн-заявки-опроса, полностью согласен с ним и обещаю выполнять его безоговорочно.",
      afterAction:
        "Я гарантирую, что информация, введенная в этой онлайн-заявке-опросе, была введена мной лично и что эта информация верна и не ложна.",
    },
    actions: {
      payment: "оплатить соответствующие платежи",
      credit: "собрать документы для получения кредита",
      document: "распечатать справку",
      card: "выпустить карту",
    },
    checkbox: {
      payment: "Ознакомлен(а) с «Порядком обмена иностранной валюты»",
      default: "С условиями соглашения ознакомлен(а)",
    },
  },
  additionalDocsInfoAlert: "Банк может запросить дополнительные документы.",
  uploadedDataFiles: "Загруженные файлы и данные",
  uploaded: "Загружено",
  invalidFileType: "Недопустимый тип файла. Разрешены: PDF, JPG, JPEG, PNG",
  tb: "№",
  attachPassport: "Прикрепите ваш паспорт",
  personal_account_number: "Номер лицевого счета",
  prevPassportNumber: "Предыдущий номер паспорта",
  inputHere: "Введите тут",
  invalidCharacters: "Недопустимые символы: < > \\ ` запрещены",
  fileExpired: "Истёк срок",
  fileExpiredReupload: "Загрузите заново",
  reuseFile: "Использовать предыдущий",
  expiresAt: "Срок действия",
  interConfirmCheckobox:
    "Я подтверждаю, что внес информацию в эту онлайн-заявку самостоятельно и эта информация является достоверной и не содержит ложных сведений.",
};

export default ru;
